import { fmtNum } from "@/lib/format";
import { classifyTier, type RqcShipment } from "@/domain/rqc";

/** "YYYY-MM-DD" → "5월 16일" (leading zero 제거). 잘못된 입력은 원본 그대로 */
export function formatMonthDay(dateStr: string): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  const [, m, d] = dateStr.split("-");
  return `${parseInt(m, 10)}월 ${parseInt(d, 10)}일`;
}

export function fmt(n: number | null | undefined, digits = 1): string {
  if (n == null || !Number.isFinite(n)) return "-";
  return fmtNum(n, digits);
}

export interface RqcSummary {
  total: number;
  cntGov: number;
  cntCust: number;
  qtyTotal: number;
  qtyGov: number;
  qtyCust: number;
  shipTotal: number;
  shipGov: number;
  shipCust: number;
  remainTotal: number;
  carsTotal: number;
}

export function summarize(rows: RqcShipment[]): RqcSummary {
  const out: RqcSummary = {
    total: rows.length,
    cntGov: 0,
    cntCust: 0,
    qtyTotal: 0,
    qtyGov: 0,
    qtyCust: 0,
    shipTotal: 0,
    shipGov: 0,
    shipCust: 0,
    remainTotal: 0,
    carsTotal: 0,
  };
  for (const r of rows) {
    const qty = Number(r.qty) || 0;
    const shipped = Number(r.shipped) || 0;
    const remain = Number(r.remain) || 0;
    const cars = Number(r.cumcars) || 0;
    const tier = classifyTier(r);
    out.qtyTotal += qty;
    out.shipTotal += shipped;
    out.remainTotal += remain;
    out.carsTotal += cars;
    if (tier === "gov") {
      out.cntGov += 1;
      out.qtyGov += qty;
      out.shipGov += shipped;
    } else {
      out.cntCust += 1;
      out.qtyCust += qty;
      out.shipCust += shipped;
    }
  }
  return out;
}
